import pino from "pino";

// Create logger without transport workers (which cause issues in Next.js)
// For production use with Loki, consider using a different approach like:
// 1. Sending logs to a log aggregation endpoint via HTTP
// 2. Using Vercel's built-in logging
// 3. Using a sidecar logging service
export const logger = pino({
  level: process.env.INTERNAL_DASHBOARD__LOG_LEVEL ?? "info",
  // Add base properties that will be included in every log
  base: {
    service: process.env.INTERNAL_DASHBOARD__SERVICE_NAME ?? "internal_dashboard",
    env: process.env.INTERNAL_DASHBOARD__ENVIRONMENT ?? "local",
  },
  // Note: We're not using pino.transport() here because it creates worker threads
  // which are incompatible with Next.js runtime and cause "worker has exited" errors
});
